import { environment } from 'environments/environment';
import { WorkspaceLifecycle } from 'app/app.types';

function resolveLifecycle(appLifecycle?: WorkspaceLifecycle | null): WorkspaceLifecycle | null {
    return appLifecycle ?? environment.app_lifecycle ?? null;
}

export function isAppInMaintenance(
    appStatus?: string | null,
    appLifecycle?: WorkspaceLifecycle | null
): boolean {
    const status = `${appStatus ?? environment.app?.status ?? ''}`.toUpperCase();
    if (status === 'INACTIVE' || status === 'DELETED') {
        return true;
    }

    const lifecycle = resolveLifecycle(appLifecycle);
    if (lifecycle?.unavailable === true) {
        return true;
    }

    return lifecycle?.blocked === true;
}
